import { MouseEvent, ReactElement, useState } from 'react';
import { Chip, ChipProps, Stack } from '@mui/material';
import { INFO_POPOVER_TRIGGER_PROPS, InfoPopover, InfoPopoverItem } from '../InfoPopover';

export type PowerAssetDetail = {
  label: string;
  value: string | number | null | undefined;
  // Renders a dot in front of the value, coloured from the asset's status.
  showStatusDot?: boolean;
  dotColor?: string;
};

export type PowerAssetChipProps = {
  id?: string | number;
  name: string;
  icon?: ReactElement;
  color?: ChipProps['color'];
  statusIcon?: ReactElement;
  statusColor?: string;
  details: PowerAssetDetail[];
  testId: string;
};

// Shared chip + details popover for both power input and power output diagram assets.
export function PowerAssetChip({
  id,
  name,
  icon,
  color = 'accent',
  statusIcon,
  statusColor,
  details,
  testId,
}: PowerAssetChipProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Chip
        size="large"
        color={color}
        icon={icon}
        label={
          <Stack direction="row" alignItems="center" gap={1}>
            <span>{name}</span>
            {statusIcon}
          </Stack>
        }
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
        data-testid={testId}
        {...INFO_POPOVER_TRIGGER_PROPS}
      />
      <InfoPopover
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        title={id != null ? `${name} ${id}` : name}
        icon={icon}
      >
        {details.map(({ label, value, showStatusDot, dotColor }) => (
          <InfoPopoverItem
            key={label}
            label={label}
            value={value}
            dotColor={dotColor ?? (showStatusDot ? statusColor : undefined)}
          />
        ))}
      </InfoPopover>
    </>
  );
}
